import { MainLayout } from "../../index.style";
import { LargeText, SmallText } from "../../styles/global/main.style";
import { SuccessWrapper } from "../../styles/pages/success.style";

const SuccessPage = () => {
  return (
    <MainLayout>
      <SuccessWrapper>
        <img id="check-icon" src="/images/successCheck.svg" />
        <LargeText>Message Sent!</LargeText>
        <div className="contact-methods">
          <SmallText>
            Thank you for reaching out! Our freight brokerage team will review
            your message and respond promptly to discuss your transportation
            needs. We look forward to providing you with efficient and reliable
            logistics solutions.
          </SmallText>
          <SmallText className="contact-method">
            <img src="../images/mail-ico.svg" alt="mail img" />
            service@reliabletruckinggroup.com{" "}
          </SmallText>
          <SmallText className="contact-method">
            <img src="../images/phone-ico.svg" alt="mail img" />
            +1 (833) 425-5643
          </SmallText>
        </div>
        <div className="hours-wrapper">
          <LargeText>Hours</LargeText>
          <SmallText id="hours-desc">
            Our freight brokerage team is available 24/7 to assist you with your
            transportation needs. We provide round-the-clock support, including
            weekends and holidays, ensuring your shipments are managed
            efficiently at all times.
          </SmallText>
        </div>
      </SuccessWrapper>
    </MainLayout>
  );
};

export default SuccessPage;
